import { gql } from 'react-apollo';

/**
* Exam decision window. Note: must use FYM_WIZARDS_BACKEND_URL endpoint.
*/
export const getExam = `
  query getExam{
    examResponsesWindow {
      isExamResponsesOn
      expireDate
    }
  }
`;

/**
* Wizard video data. Note: must use FYM_WIZARDS_BACKEND_URL endpoint.
*/
export const wizardVideo = `
query getWizardVideo{
    video {
      version
      url
      hasViewed
      questions
      answers
      progress
      duration
      isFirstTime
      completedViewAt
      createdAt
    }
  }
`;

// Returns an array of all the subjects a user is enrolled in
export const getSubjects = gql`
query getSubjects{
  subjects {
    name
    optionYes
    optionNo
    isConfirmed
    selectedOption
    rejectionReason
    variations
    selectedVariation
    variationsDisplay
    selectedVariationDisplay
  }
}
`;

export const getVideo = gql`
query getVideo{
  video {
    url
    progress
    duration
    hasViewed
  }
}
`;

export const getVideoQuestions = gql`
query getVideoQuestions{
  video {
    introduction
    questions
    answers
    progress
  }
}
`;

export const updateSubjectDecisions = gql`
mutation SubjectMutation($subjects: [SubjectInput]) {
  updateSubjects(subjects: $subjects) {
    ok
  }
}
`;

// This call will be made on exiting a video wizard
export const updateVideoProgress = gql`
mutation VideoProgressMutation($progress: Int!) {
  updateVideoProgress (progress: $progress) {
    ok
  }
}
`;

// Thils call will be used on submit of video wizard
export const updateVideoResponses = gql`
mutation VideoProgressMutation($answers: [AnswerInput]) {
  updateVideoProgress (answers: $answers) {
    ok
  }
}
`;

// This call will be made on exiting a video wizard
export const storeDailyVideoProgress = gql`
mutation StoreDailyVideoProgressMutation(
    $userId: Int!
    $cbPersonid: String!
    $videoId: Int!
    $status: String!
    $progress: String!
    $watchedPercentage: String!
    $playTimePercentage: String
  ) {
  storeDailyVideoProgress (
    userId: $userId,
    videoId: $videoId,
    status: $status,
    cbPersonid: $cbPersonid,
    progress: $progress,
    watchedPercentage: $watchedPercentage
    playTimePercentage: $playTimePercentage
  ) {
    ok
  }
}
`;


export const getUserDailyProgress = gql`
  query dailyVideoProgress($userId: Int!, $videoId: Int!) {
    videoProgress(userId: $userId, videoId: $videoId)
  }
`;
